module.exports = __webpack_public_path__ + "static/media/secuencias.9ab793ba.svg";